$('input[data-autocomplete]').each(function () {
  var searchField = $(this),
    form = searchField.parent('form'),
    autoCompleteUrl = searchField.data('autocomplete');

  searchField.autocomplete({
    serviceUrl: autoCompleteUrl,
    minChars: 2,
    zIndex: 1,
    triggerSelectOnValidInput: false,
    appendTo: form,
    onSelect: function () {
      if (searchField.is('[data-autocomplete-auto-submit]')) {
        form.submit();
      }
    }
  });
});




// WEBPACK FOOTER //
// ./javascripts/components/legacy/init/autocomplete.js